import {EditPaymentRequestBody, TenantBankAccount} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {FormValuesType} from '../types/FormValuesType';

type GetTenantBankAccount = (value: string | Nullish) => TenantBankAccount | null;

/**
 * Takes the account lookup from the caller's `usePaymentTenantBankAccounts`, which knows what the
 * `tenantBankAccount` field holds in the current mode.
 */
export const useGetSubmitBody = (getTenantBankAccount: GetTenantBankAccount) => {
  const getPaymentBody = (data: FormValuesType): EditPaymentRequestBody => {
    const comment = data.note ?? '';
    const exchangeRate = data.exchangeRate?.toString() || null;

    return {
      paymentMethod: data.paymentMethod ?? null,
      dueDate: data.dueDate ?? null,
      cashRegisterId: data.cashRegisterId ?? null,
      customerBankAccountId: data.customerBankAccountId ?? null,
      tenantBankAccount: getTenantBankAccount(data.tenantBankAccount),
      amount: data.amount?.toString() ?? null,
      comment: comment ?? null,
      exchangeRate: exchangeRate ?? null,
      supplierInvoiceNumber: data.supplierInvoiceNumber ?? null,
      dateOfTaxableSupply: data.dateOfTaxableSupply ?? null,
      createCashRegisterDocument: data.createCashRegisterDocument ?? false,
    };
  };

  return [getPaymentBody] as const;
};
